(function () {
  // DvzlaStore: lupa/magnifier effect that follows the cursor on the main
  // product image (desktop only). Scoped strictly to the product page's
  // <media-gallery> component so it never touches other carousels on the site.

  var ZOOM_SCALE = 1.9;

  function isTouchDevice() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
  }

  function setupGallery(gallery) {
    if (isTouchDevice()) return;

    var container = gallery.querySelector('slideshow-container') || gallery;

    container.addEventListener('mousemove', function (event) {
      var activeImg = gallery.querySelector('slideshow-slide[aria-hidden="false"] .product-media__image, slideshow-slide[aria-hidden="false"] img');
      if (!activeImg) return;

      var rect = activeImg.getBoundingClientRect();
      var x = ((event.clientX - rect.left) / rect.width) * 100;
      var y = ((event.clientY - rect.top) / rect.height) * 100;

      if (x < 0 || x > 100 || y < 0 || y > 100) return;

      activeImg.style.transformOrigin = x + '% ' + y + '%';
      activeImg.style.transform = 'scale(' + ZOOM_SCALE + ')';
      activeImg.classList.add('dvzla-zoomed');
    });

    container.addEventListener('mouseleave', function () {
      var images = gallery.querySelectorAll('.dvzla-zoomed');
      images.forEach(function (img) {
        img.style.transform = '';
        img.style.transformOrigin = '';
        img.classList.remove('dvzla-zoomed');
      });
    });
  }

  function init() {
    var galleries = document.querySelectorAll('media-gallery');
    galleries.forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
